import moment from 'moment';

/**
 * Calculates the status of an auction start time relative to the current time
 * @param {string|Date|moment.Moment} date - The start time of the auction
 * @returns {Object} - Object containing statusText, statusColor, formattedDate, and tooltipText
 */
export const getAuctionStartTimeStatus = (date) => {
    if (!date) {
        return {
            statusText: '',
            statusColor: '',
            formattedDate: '-',
            tooltipText: null
        };
    }

    const startTime = moment(date);
    const now = moment();
    const diffInHours = startTime.diff(now, 'hours', true);
    const diffInMinutes = startTime.diff(now, 'minutes', true);

    let statusText = '';
    let statusColor = '';

    if (startTime.isBefore(now)) {
        // Time has passed
        statusText = 'Time passed';
        statusColor = 'red';
    } else if (diffInHours <= 1 && diffInMinutes > 0) {
        // Starting within 1 hour
        statusText = 'Starting soon';
        statusColor = 'orange';
    } else if (diffInHours <= 24 && diffInHours > 0) {
        // Starting within 24 hours
        statusText = 'Starting soon';
        statusColor = 'orange';
    }

    return {
        statusText,
        statusColor,
        formattedDate: startTime.format('YYYY-MM-DD HH:mm'),
        tooltipText: `Auction starts on ${startTime.format('MMMM Do, YYYY [at] h:mm A')}`
    };
};

